import { colorsSoilMoisture, findClosest } from "@helper/colors";

export function getSoilMoistureGaugeColor(tree, moistureValue, fallbackColor = "#8AABBE") {
  if (moistureValue == null || Number.isNaN(Number(moistureValue))) return fallbackColor;

  const soil = tree?.soil;
  const scale = colorsSoilMoisture(
    soil ? soil.pwp : 10,
    soil ? soil.max_nf : 25,
    soil ? soil.max_f : 45
  );
  const normalizedValue = Math.max(0, Math.min(100, Number(moistureValue))) / 100;

  return findClosest(normalizedValue, scale)?.[1] || fallbackColor;
}
